import * as React from 'react';

function SvgPlayButtonCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
      <path
        fill="#BFBDFF"
        d="M8.8 13.9l4.67-3.5c.27-.2.27-.6 0-.8L8.8 6.1a.5.5 0 00-.8.4v7c0 .41.47.65.8.4zM10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
      />
    </svg>
  );
}

export default SvgPlayButtonCircle;
